import { NgModule } from '@angular/core'

import { SharedModule } from '@shared/shared.module'

import { SosTriggerDirective } from './sos-trigger.directive'
import { SosListComponent } from './sos-list/sos-list.component'
import { SosAlertComponent } from './sos-list/sos-alert/sos-alert.component'
import { SosAcknowledgeDialogComponent } from './sos-acknowledge-dialog/sos-acknowledge-dialog.component'

@NgModule({
  declarations: [SosTriggerDirective, SosListComponent, SosAlertComponent, SosAcknowledgeDialogComponent],
  imports: [SharedModule],
  exports: [SosTriggerDirective, SosListComponent],
})
export class SosModule {}
